var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg04(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 386,
    height: 248,
    viewBox: "0 0 386 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.728 123.472C0.728 161.312 8.75467 191.355 24.808 213.6C41.0907 235.845 66.3173 246.968 100.488 246.968C134.659 246.968 159.885 235.845 176.168 213.6C192.451 191.355 200.592 161.312 200.592 123.472C200.592 85.8613 192.451 55.9333 176.168 33.688C159.885 11.4427 134.659 0.31999 100.488 0.31999C66.3173 0.31999 41.0907 11.4427 24.808 33.688C8.75467 55.704 0.728 85.632 0.728 123.472ZM133.856 123.472C133.856 142.507 131.563 157.184 126.976 167.504C122.619 177.824 113.789 182.984 100.488 182.984C87.1867 182.984 78.2427 177.824 73.656 167.504C69.2987 157.184 67.12 142.507 67.12 123.472C67.12 104.667 69.2987 90.104 73.656 79.784C78.2427 69.464 87.1867 64.304 100.488 64.304C113.789 64.304 122.619 69.464 126.976 79.784C131.563 90.104 133.856 104.667 133.856 123.472ZM229.254 206.72V150.304L335.894 1.00798H408.822V148.24H435.654V206.72H408.822V248H340.71V206.72H229.254ZM345.87 78.408L297.366 148.24H345.87V78.408Z",
    fill: "#EAF0F5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg04);
export default __webpack_public_path__ + "static/media/04.7fc634d33e2a88fab22d0e9aaec7c11b.svg";
export { ForwardRef as ReactComponent };